var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dialog-bubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 1C4.13402 1 1.00002 4.13401 1.00002 8C1.00002 9.02563 1.22121 10.0019 1.6191 10.8818L1.02043 13.799C0.952859 14.1282 1.05523 14.4694 1.29291 14.7071C1.53059 14.9448 1.87178 15.0472 2.20105 14.9796L5.11825 14.3809C5.99811 14.7788 6.97438 15 8.00002 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8.00002 1Z",
    fill: "#11232E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogBubble);
export default __webpack_public_path__ + "static/media/dialog-bubble.b1de0e71af30bdd48bf54fc195b79730.svg";
export { ForwardRef as ReactComponent };